(function() {
    'use strict';
    angular
        .module('quantixApp')
        .factory('CompanyReportService', CompanyReportService);

        CompanyReportService.$inject = ['$http', '$q'];

    function CompanyReportService($http, $q) {

        
        var requestNewCompany = function(newCompanyDetails) {
            return $http.post('api/companyProfile/requestnewcompany', newCompanyDetails, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var checkEfexternalUser = function(companyCode) {
            return $http.post('api/companyProfile/checkifvalidsubscription', companyCode, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var getCurrentUserType = function() {
            return $http.get('api/companyProfile/getcurrentusertype', {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var getCompanyDetails = function(companyCode) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/getcompanydetails', companyCode, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var getSmeAvailableData = function() {
            var deferred = $q.defer();
            $http.post('api/companyProfile/getSmeAvailableData',{
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }



        var generateCompanyReport = function(companyDetails) {
            var deferred = $q.defer();
            $http.post('api/companyreportjsongenerator/getjson', companyDetails, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var saveCompanyInfoAdmin = function(companyInfoAdmin) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/savecompanyinfoadmin', companyInfoAdmin, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var updateAssociateUsersLimit = function(clientAssociates) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/updateassociateuserslimit', clientAssociates, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var saveClientSubscriptionLimit = function(limit) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/saveclientsubscriptionlimit', limit, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var deleteCompanyInfoAdmin = function(companyInfoAdmin) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/deletecompanyinfoadmin', companyInfoAdmin, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }}).then(function(response) {
                        deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

		var getClientUsers = function(clientsStr) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getallclientusers';
			$http.post(url, clientsStr, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        
        var assignTemplateUsers = function(clientsStr) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/assigntemplateusers';
			$http.post(url, clientsStr, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getClientAssociateUsers = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getallclientassociateusers';
			$http.get(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        
        var applyFilters = function(filters) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/applyfilterfordownloads';
			$http.post(url, filters, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getDownloads = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getdownloads';
			$http.get(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getCompaniesForAlert = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getcompaniesforalert';
			$http.get(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getRecentViewedCompanies = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getallrecentlyviewedCompaniesforcompanyreport';
			$http.get(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getClientNameList = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getclientnamelist';
			$http.get(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        
        var setAlert = function(alertDto) {
            return $http.post('api/companyProfile/setalert', alertDto, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var getCompaniesListByNameForCompanyReportAlert = function(searchText, companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompaniesByNameForCompanyReport';
			$http.get(url, {
				params : {
                    searchText : searchText,
                    companies: companies
				},
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
        }
        
        var getCompanyReportTemplates = function(subscription) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getcompanytemplates';
			$http.post(url, subscription, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        var findAllTemplateParams = function(moduleFlag) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getcompanyreporttemplateparams';
			$http.post(url, moduleFlag, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        


        var getDefaultParamJson = function(moduleFlag) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getdefaultparamjson';
			$http.post(url, moduleFlag, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        } 

        var saveTemplate = function(templateJson) {
            return $http.post('api/companyProfile/savecustomtemplate', templateJson, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var saveTemplateForAdminEdit = function(templateJson) {
            return $http.post('api/companyProfile/savetemplateforadminedit', templateJson, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var deletetemplate = function(templateJson) {
            return $http.post('api/companyProfile/deletecustomtemplate', templateJson, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var deleteTemplateByAdmin = function(templateJson) {
            return $http.post('api/companyProfile/deletecustomtemplatebyadmin', templateJson, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var getCompaniesByNameForPeers = function(searchCriteria) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getCompaniesByNameForPeers';
			$http({
				url: url,
				method: 'POST',
				data: searchCriteria,
				ignoreLoadingBar: true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
            return deferred.promise;
        }

        var getClientTemplates = function(clientModel) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getTemplateAdminData';
			$http.post(url, clientModel, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getadminTemplatenamelist = function() {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getadminTemplatenamelist';
			$http.post(url, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var assignTemplateToUsers = function(assignObj) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/assignAdminTemplateToClient';
			$http.post(url, assignObj, {
				responseType : 'application/text',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var saveOrEditTemplate = function(templateJson) {
            return $http.post('api/companyProfile/saveOrEditcustomtemplate', templateJson, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var setRestrictiveAccess = function(accessDto) {
            return $http.post('api/companyProfile/saverestrictiveaccess', accessDto, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var getClientRestrictions = function(accessDto) {
            return $http.post('api/companyProfile/getrestrictiveaccess', accessDto, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
        
        var applyFiltersMytemplate = function(filters) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/applyfilterforMyTemplate';
			$http.post(url, filters, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }
        
        var getTeamDownloads = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getClientTeamDownload';
			$http.get(url,{
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var getTeamDownloadsExt = function(clientModel) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getClientTeamDownloadExt';
			$http.post(url, clientModel,{
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var applyTeamDownloadFilters = function(filters) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/filterClientTeamDownload';
			$http.post(url, filters, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var applyTeamDownloadFiltersExt = function(filters) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/filterClientTeamDownloadExt';
			$http.post(url, filters, {
				responseType : 'application/json',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var saveScorecardDataToJson = function(obj) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/getcompanyscorecarddatalist';
			$http.post(url, obj, {
				responseType : 'application/text',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var deleteScorecardJsonFile = function(fileName) {
            var deferred = $q.defer();
			var url = 'api/companyProfile/deletefile';
			$http.post(url, fileName, {
				responseType : 'application/text',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var uploadAxisAmcReport = function(formData) {
            var deferred = $q.defer();
            $http.post('api/companyProfile/uploadReport', formData, {
                responseType : 'application/json',
                  headers : {
                         'Content-Type' : undefined
                  }}).then(function(response) {
                            deferred.resolve(response);
                    }, function(errordata) {
                    deferred.reject(errordata);
                });
           return deferred.promise;
        }

        var getAxisAmcreportUploads = function() {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getaxisamcreportuploads';
			$http.get(url, {
				responseType : 'application/text',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
        }

        var deleteAxisAmcReport = function(report) {
            return $http.post('api/companyProfile/deleteUploadedReport', report, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }

        var notifyAxisAmcReport = function(report) {
            return $http.post('api/companyProfile/notifyclient', report, {
                responseType : 'application/text',
                  headers : {
                         'Content-Type' : 'application/json'
                  }});
        }
		return {
            getCompaniesListByNameForCompanyReportAlert: getCompaniesListByNameForCompanyReportAlert,
            getClientUsers : getClientUsers,
            requestNewCompany : requestNewCompany,
            getCompanyDetails : getCompanyDetails,
            generateCompanyReport : generateCompanyReport,
            saveCompanyInfoAdmin: saveCompanyInfoAdmin,
            deleteCompanyInfoAdmin : deleteCompanyInfoAdmin,
            getClientAssociateUsers : getClientAssociateUsers,
            updateAssociateUsersLimit: updateAssociateUsersLimit,
            getDownloads : getDownloads,
            getCompaniesForAlert: getCompaniesForAlert,
            setAlert : setAlert,
            getRecentViewedCompanies : getRecentViewedCompanies,
            saveClientSubscriptionLimit : saveClientSubscriptionLimit,
            getClientNameList : getClientNameList,
            checkEfexternalUser : checkEfexternalUser,
            getCurrentUserType : getCurrentUserType,
            applyFilters : applyFilters,
            getCompanyReportTemplates : getCompanyReportTemplates,
            findAllTemplateParams : findAllTemplateParams,
            getDefaultParamJson: getDefaultParamJson,
            saveTemplate : saveTemplate,
            deletetemplate:deletetemplate,
            getCompaniesByNameForPeers : getCompaniesByNameForPeers,
            getClientTemplates: getClientTemplates,
            deleteTemplateByAdmin: deleteTemplateByAdmin,
            getadminTemplatenamelist: getadminTemplatenamelist,
            assignTemplateUsers: assignTemplateUsers,
            assignTemplateToUsers: assignTemplateToUsers,
            saveTemplateForAdminEdit: saveTemplateForAdminEdit,
            saveOrEditTemplate:saveOrEditTemplate,
            setRestrictiveAccess: setRestrictiveAccess,
            getClientRestrictions: getClientRestrictions,
            applyFiltersMytemplate: applyFiltersMytemplate,
            getTeamDownloads : getTeamDownloads,
            getTeamDownloadsExt : getTeamDownloadsExt,
            applyTeamDownloadFilters: applyTeamDownloadFilters,
            applyTeamDownloadFiltersExt: applyTeamDownloadFiltersExt,
            saveScorecardDataToJson: saveScorecardDataToJson,
            deleteScorecardJsonFile: deleteScorecardJsonFile,
            uploadAxisAmcReport: uploadAxisAmcReport,
            getAxisAmcreportUploads: getAxisAmcreportUploads,
            deleteAxisAmcReport: deleteAxisAmcReport,
            notifyAxisAmcReport: notifyAxisAmcReport,
            getSmeAvailableData:getSmeAvailableData
        }

    }
})();